import { useState, useCallback } from "react";
import { desactiveDocumentURL } from "../../utils/ConstantsURL";

export const useDeleteDocument = (token) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const deleteDocument = useCallback(
    async (id_document, flg_activo) => {
      setLoading(true);
      setError(null);
      
      try {
        const response = await fetch(desactiveDocumentURL(), {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ id_document, flg_activo }),
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.message || "Error al cambiar el estado del documento");
        }

        setData(result);
        return { success: true, data: result };
      } catch (err) {
        const errorMessage = err.message || "Error en la conexión";
        setError(errorMessage);
        return { success: false, error: errorMessage };
      } finally {
        setLoading(false);
      }
    },
    [token]
  );

  return { deleteDocument, loading, error, data };
};

export default useDeleteDocument;
